import MCheckbox from '@mui/joy/Checkbox';

export const Checkbox: typeof MCheckbox = MCheckbox;
